function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgDinheiroNaMao = function SvgDinheiroNaMao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85 19.803a1.086 1.086 0 01.913-.457h6.391c.507 0 3.296-2.798 3.652-3.196a24.197 24.197 0 002.283-3.652 1.826 1.826 0 00-1.826-.456c-.808.187-1.283.767-1.826 1.826l-2.09 1.086",
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.59 16.607h3.651c1.826 0 1.826-2.283 0-2.283h-2.41c-.383 0-1.096-.913-1.698-.913H7.85a3.195 3.195 0 00-1.826.913L4.198 16.15m-.916-.914L1 17.518l5.478 5.478 2.282-2.282-5.478-5.478zm.003 2.284l.913.913M18.747 12.238a3.8 3.8 0 00.06-.653c0-2.392-1.498-4.565-4.11-6.39m-2.282-.001c-2.61 1.826-4.108 3.99-4.108 6.391a3.087 3.087 0 00.561 1.826",
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.698 5.194c-.119.183-.836.274-1.141.274a2.241 2.241 0 01-1.142-.274s-1.324-2.451-1.269-2.547c.48-.859 1.475-.694 2.41-.457a6.3 6.3 0 002.119.265c.023.347-.977 2.74-.977 2.74zm-2.739 5.935v.456a.913.913 0 00.913.913h.913a.913.913 0 00.913-.913v-.255a.913.913 0 00-.626-.868l-1.488-.493a.913.913 0 01-.625-.867v-.256a.913.913 0 01.913-.913h.913a.913.913 0 01.913.913v.457m-1.37-1.37V7.02m0 5.478v.913",
    stroke: props.color
  }));
};
SvgDinheiroNaMao.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgDinheiroNaMao.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgDinheiroNaMao;